
export {StompService, StompState} from './src/stomp.service';
export {StompConfig} from './src/stomp.config';



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/node_modules/@stomp/ng2-stompjs/index.ts